import React from "react";
import moment from "moment";

const BestImprovementAwardPDF = ({ formData }) => {
    const formattedDate = formData.date_submission
        ? moment(formData.date_submission).format("YYYY-MM-DD")
        : "";

    // Common Styles to keep code clean
    const labelStyle = { width: "40%", fontFamily: "Arial, sans-serif", fontWeight: 400, fontSize: "14px", verticalAlign: "middle", padding: "5px 0" };
    const valueStyle = { fontFamily: "Arial, sans-serif", fontWeight: 400, fontSize: "14px", borderBottom: "1px solid #000", verticalAlign: "middle", padding: "5px 0" };
    const boxStyle = { fontFamily: "Arial, sans-serif", fontWeight: 400, fontSize: "14px", border: "1px solid #000", minHeight: "100px", padding: "10px", marginTop: "5px" };
    const headerStyle = { fontFamily: "Arial, sans-serif", fontWeight: 600, fontSize: "20px", padding: "15px 0 10px" };

    return (
        <div id="pdf-content" style={{ width: "700px", margin: "0 auto", padding: "20px", backgroundColor: "#fff" }}>
            
            {/* Title Section */}
            <div style={{ textAlign: "center", marginBottom: "30px" }}>
                <h1 style={{ fontFamily: "Arial, sans-serif", fontWeight: 700, fontSize: "28px", margin: 0, textTransform: "uppercase" }}>
                    Best Improvement Award Submission
                </h1>
            </div>

            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <tbody>
                    <tr>
                        <td>
                            {/* Employee Information Section */}
                            <table style={{ width: "100%", marginBottom: "20px" }}>
                                <tbody>
                                    <tr><td colSpan="2" style={headerStyle}>Employee Information</td></tr>
                                    <tr>
                                        <td style={labelStyle}><ul style={{ padding: "0 13px", margin: 0 }}><li>Full Name</li></ul></td>
                                        <td style={valueStyle}>{formData.full_name}</td>
                                    </tr>
                                    <tr>
                                        <td style={labelStyle}><ul style={{ padding: "0 13px", margin: 0 }}><li>Department</li></ul></td>
                                        <td style={valueStyle}>{formData.department}</td>
                                    </tr>
                                    <tr>
                                        <td style={labelStyle}><ul style={{ padding: "0 13px", margin: 0 }}><li>Job Title</li></ul></td>
                                        <td style={valueStyle}>{formData.job_title}</td>
                                    </tr>
                                    <tr>
                                        <td style={labelStyle}><ul style={{ padding: "0 13px", margin: 0 }}><li>Date of Submission</li></ul></td>
                                        <td style={valueStyle}>{formattedDate}</td>
                                    </tr>
                                </tbody>
                            </table>

                            {/* Improvement Idea Section */}
                            <table style={{ width: "100%", marginBottom: "20px" }}>
                                <tbody>
                                    <tr><td colSpan="2" style={headerStyle}>Improvement Idea</td></tr>
                                    <tr>
                                        <td style={labelStyle}><ul style={{ padding: "0 13px", margin: 0 }}><li>Title of Improvement Idea</li></ul></td>
                                        <td style={valueStyle}>{formData.improvement_idea}</td>
                                    </tr>
                                    <tr>
                                        <td style={labelStyle}><ul style={{ padding: "0 13px", margin: 0 }}><li>What department does this idea pertain to?</li></ul></td>
                                        <td style={valueStyle}>{formData.department_idea}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2" style={{ padding: "10px 0" }}>
                                            <ul style={{ padding: "0 13px", margin: "0 0 5px" }}><li>Describe your improvement idea in detail</li></ul>
                                            <div style={boxStyle}>{formData.improvement_details}</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            {/* Implementation Plan Section */}
                            <table style={{ width: "100%" }}>
                                <tbody>
                                    <tr><td style={headerStyle}>Implementation Plan</td></tr>
                                    <tr>
                                        <td style={{ padding: "10px 0" }}>
                                            <ul style={{ padding: "0 13px", margin: "0 0 5px" }}><li>How will this improvement be implemented?</li></ul>
                                            <div style={boxStyle}>{formData.improvement_implemented}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "10px 0" }}>
                                            <ul style={{ padding: "0 13px", margin: "0 0 5px" }}><li>What resources, tools, or support are needed?</li></ul>
                                            <div style={boxStyle}>{formData.tools}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "10px 0" }}>
                                            <ul style={{ padding: "0 13px", margin: "0 0 5px" }}><li>What benefits will this improvement bring?</li></ul>
                                            <div style={boxStyle}>{formData.benefits}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "10px 0" }}>
                                            <ul style={{ padding: "0", margin: "0 0 5px", listStyleType: "none" }}><li>Additional Comments</li></ul>
                                            <div style={boxStyle}>{formData.additional_comments}</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default BestImprovementAwardPDF;